"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const organizationMediaTranslations = {
    media: "Media",
    searchMedia: "Search Media",
    noMediaFound: "No Media Found",
    forwardMultipleMedia: "Forward Multiple Media",
    organizationMedia: "Organization Media",
    imagesVideos: "Images & Videos",
    documents: "Documents",
    forwardMedia: "Forward Media",
    forwardTo: "Forward To",
};
exports.default = organizationMediaTranslations;
